/**
 * Every interface language, in picker order: `val` is the i18next code (also
 * sent to the API as `Accept-Language`), `name` the native label shown in the
 * language pickers (navigation surface and account options).
 *
 * Adding a language: add its `src/assets/translations/<folder>` file, import
 * it in `src/i18n.js`, then register it here.
 */
export const LANGUAGES = [
	{ name: "Français", val: "fr" },
	{ name: "English", val: "en" },
	{ name: "Español", val: "es" },
	{ name: "Deutsch", val: "de" },
	{ name: "Italiano", val: "it" },
	{ name: "Português (Brasil)", val: "pt-BR" },
]

export const SUPPORTED_LANGUAGES = LANGUAGES.map(({ val }) => val)

export const FALLBACK_LANGUAGE = "en"
